import { FirestoreCollections, ID } from '@griply/types';

import { BatchDocuments, WriteBatchFn } from '../batch-documents';
import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';

export type DeleteTasksOptions<
  TDocRef = unknown,
  TCollectionRef = unknown,
  TDb = FirestoreInstance,
> = {
  taskIds: ID[];
  collection: (
    db: NoInfer<TDb>,
    path: string,
    ...rest: string[]
  ) => TCollectionRef;
  doc: (collectionRef: NoInfer<TCollectionRef>, id: ID) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
  writeBatch?: WriteBatchFn<NoInfer<TDocRef>, NoInfer<TDb>>;
  onWriteError: (error: unknown) => void;
};

export const deleteTasks = async <
  TDocRef,
  TCollectionRef,
  TDb = FirestoreInstance,
>(
  options: DeleteTasksOptions<TDocRef, TCollectionRef, TDb>,
): Promise<void> => {
  const { taskIds, collection, doc, deleteDoc, db, writeBatch, onWriteError } =
    options;

  if (!taskIds.length) {
    return;
  }

  const taskCollection = collection(db, FirestoreCollections.Tasks);

  if (taskIds.length === 1 || !writeBatch) {
    taskIds.forEach((taskId) => {
      detachWrite(deleteDoc(doc(taskCollection, taskId)), onWriteError);
    });
    return;
  }

  const batchDocuments = new BatchDocuments(db, writeBatch);
  taskIds.forEach((taskId) => {
    batchDocuments.deleteDocument(doc(taskCollection, taskId));
  });
  detachWrite(batchDocuments.commit(), onWriteError);
};
